export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-line-chart-line',
      title: 'Aumento de Produtividade',
      description: 'Ganhe até 40% mais produtividade com processos otimizados e metodologia comprovada para MEI e pequenas empresas.'
    },
    {
      icon: 'ri-organization-chart',
      title: 'Processos Organizados',
      description: 'Mapeamento completo e organização de todos os processos do seu negócio para máxima eficiência operacional.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Redução de Custos',
      description: 'Identifique desperdícios e reduza custos operacionais através de análise detalhada e priorização inteligente.'
    },
    {
      icon: 'ri-time-line',
      title: 'Ganho de Tempo',
      description: 'Automatize tarefas repetitivas e foque no que realmente importa para o crescimento do seu negócio.'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipe Alinhada',
      description: 'Processos claros e documentados garantem que toda equipe trabalhe de forma sincronizada e eficiente.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Crescimento Sustentável',
      description: 'Base sólida para escalar seu negócio com segurança, previsibilidade e controle total das operações.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Por que escolher o LBAs Essentials?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transforme seu MEI ou pequena empresa com benefícios reais e mensuráveis 
            que impactam diretamente seus resultados
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-coral-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
